/**
 * Data-area constants for consistent naming across all malls
 *
 * Common components use semantic names without prefixes
 * Site-specific components use 'site-' prefix for identification
 * This makes it easy for PMs to understand and track data areas
 */

export const DATA_AREAS = {
  // ===== COMMON COMPONENTS (Cross-mall, no prefix) =====
  // These are shared components that appear the same across all malls
  ACTION_HISTORY: 'action-history',
  ATTENTION: 'attention',
  CAMPAIGN_DETAIL: 'campaign-detail',
  CAMPAIGN_SEARCH: {
    RESULT: 'campaign-search-result',
  },
  CATEGORY: 'category',
  CATEGORY_TAB_SWITCHER: 'category-tab-switcher',
  CLICK_HISTORY: 'click-history',
  CONTACT_FORM: {
    CATEGORY_SELECTOR: 'contact-form-category',
    CONSENT_FORM: 'contact-form-consent-form',
    CONTACT_FORM: 'contact-form-contact-form',
    CONTACT_HISTORY: 'contact-form-history',
    COMMENT_ATTACHMENTS: 'contact-form-comment-attachments',
    CONTACT_THANKS: 'contact-form-thanks',
  },
  EVENT: 'event',
  EVENT_LIST: 'event-list',
  FAVORITE_CAMPAIGN: 'favorite-campaign',
  FLOATING_BANNER: 'floating-banner',
  IMPORTANT_NEWS_NOTICE: 'important-news-notice',
  NEWS: 'news',
  PENDING_POINT: 'pending-point',
  POINT_HISTORY: 'point-history',
  PUSH_REWARD: 'push-reward',
  RANDOM_CAMPAIGN_LIST: 'random-campaign-list',
  RANKING: 'ranking',
  RECOMMEND_SHOP: 'recommend-shop',
  RECENT_VIEWED: 'recent-viewed',
  REWARD_SIMULATION_NOTICE: 'reward-simulation-notice',
  SEARCH_HISTORY: 'search-history',
  SHOP_NAVIGATION_BUTTON: 'shop-navigation-button',
  TOP_FULL_BANNER: 'top-full-banner',
  UNREAD_INQUIRY_NOTICE: 'unread-inquiry-notice',

  // ===== SITE COMPONENTS (Mall-specific, with 'site-' prefix) =====
  // These are unique to each mall's site structure and layout

  // ----- Common Site Components (Essentials. Used for most malls. Keeping the same name across all malls is preferred.) -----
  // Header & Footer
  SITE_HEADER: 'site-header',
  SITE_FOOTER: 'site-footer',

  // Buttons & Actions
  SITE_LOGIN_BUTTON: 'site-login-button',
  SITE_LOGOUT_BUTTON: 'site-logout-button',

  // Campaign
  SITE_SHOP_DETAILS_MAIN: 'site-shop-details-main',
  SITE_OFFER_DETAILS_MAIN: 'site-offer-details-main',
  SITE_CAMPAIGN_DETAILS_INFO: 'site-campaign-details-info', // achievement_conditions or attention (獲得条件や利用注意など)

  // Search
  SITE_CAMPAIGN_SEARCH_RESULT: 'site-campaign-search-result',

  // Section in Top Page
  SITE_EVENT_CAROUSEL: 'site-event-carousel', // 特集カルーセル

  // Surface
  SITE_STICKY_SURFACE_DISPLAY: 'site-sticky-surface-display',
  SITE_FLOATING_BANNER: 'site-floating-banner',

  // Special Modals
  SITE_RAKUTEN_CART_WARNING: 'site-rakuten-cart-warning',

  // Error & Status
  SITE_ERROR_BODY: 'site-error-body',

  // ----- Custom Site Components -----
  // Banners & Informations
  SITE_KABU_ACQUISITION_INSTRUCTION: 'site-kabu-acquisition-instruction', // kabuand
  SITE_IMPORTANT_NEWS_LIST: 'site-important-news-list', // kabuand
  SITE_HOW_TO_BANNER: 'site-how-to-banner', // aeon
  SITE_MAX_REWARD_BANNER: 'site-max-reward-banner', // aeon
  SITE_INTERSECTION_STICKY_ITEM: 'site-intersection-sticky-item', // aeon

  // Campaign Recommendations & Rankings
  SITE_POINTUP_CAROUSEL: 'site-pointup-carousel', // kabuand
  SITE_SHOP_RANKING: 'site-shop-ranking', // kabuand
  SITE_POINTUP_RECOMMEND_SHOPS: 'site-pointup-recommend-shops', // aeon
  SITE_RECOMMEND_RANKING: 'site-recommend-ranking', // aeon
  SITE_SPECIAL_EVENT: 'site-special-event', // aeon
  SITE_GUIDE_SHOP_RANKING: 'site-guide-shop-ranking', // aeon

  // Modals
  SITE_SAFARI_MODAL: 'site-safari-modal', // kabuand
  SITE_MODAL_PLUS_MEMBER: 'site-modal-plus-member', // kabuand
  SITE_SEARCH_CATEGORY_SELECT_MODAL: 'site-search-category-select-modal', // kabuand
  SITE_MODAL_SEARCH_KEYWORD: 'site-modal-search-keyword', // kabuand

  // Special Features
  SITE_CHATBOT: 'site-chatbot', // kabuand
};
